import { forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Fade, FadeProps } from '@material-ui/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { duration } from '@material-ui/core/styles/transitions';

type FadeInProps = FadeProps & {
  visible?: boolean;
  timeout?: number;
};

export const FadeIn = forwardRef(
  (
    {
      visible = true,
      timeout = duration.shorter,
      children,
      ...fadeProps
    }: FadeInProps,
    ref,
  ) => (
    <Fade
      ref={ref}
      unmountOnExit
      mountOnEnter
      {...fadeProps}
      in={visible}
      timeout={timeout}
      exit={false}
    >
      {children}
    </Fade>
  ),
);
